<template>
  <div>
    <loader :isShow="isLoading" :textInfo="''" />
    <div class="new-notification-form">
      <section class="form-body">
        <div class="subtitle HEL">{{ this.subtitle }}</div>
        <div v-if="incompleteForm" class="error-message">
          * Please fill required fields
        </div>
        <ul v-if="incompleteForm" class="field-errors">
          <li v-if="!validType">Type of notification is required</li>
          <li v-if="!validProperty">Property is required</li>
          <li v-if="!validChore">Chore is required</li>
          <li v-if="!validDate">Frequency is required</li>
          <li v-if="!validStartDate && selectedType === 'schedule'">
            Start date is required
          </li>
          <li v-if="!validTime">Time is required</li>
          <li v-if="!validMessage">Message is required</li>
        </ul>

        <div class="row HEL">
          <div class="column-3">
            <label>Type of notification:</label>
            <div class="notification-type-container">
              <div
                v-for="type of types"
                class="notification-type"
                :class="{
                  'notification-type-selected':
                    selectedType == type ? true : false,
                  error: !validType
                }"
                :key="type"
                @click="selType(type)"
              >
                {{ type }}
              </div>
            </div>
          </div>
        </div>

        <div class="row HEL">
          <div
            class="column"
            :class="{ 'column-3': selectedType == 'schedule' ? true : false }"
          >
            <label>Property:</label>
            <select
              class="tall-input"
              v-model="property"
              :class="{ error: !validProperty }"
              @change="onChangeProperty()"
            >
              <option selected :value="null">Select Property</option>
              <option
                v-for="property of properties"
                :key="'property-' + property.uuid"
                :value="property.uuid"
              >
                {{ property.name }}
              </option>
            </select>
          </div>
          <div
            class="column"
            :class="{ 'column-3': selectedType == 'schedule' ? true : false }"
          >
            <label>Chore:</label>
            <select
              class="tall-input"
              v-model="chore"
              :class="{ error: !validChore }"
            >
              <option selected :value="null">Select Chore</option>
              <option
                v-for="chore of chores"
                :key="'chore-' + chore.uuid"
                :value="chore.uuid"
              >
                {{ chore.name }}
              </option>
            </select>
          </div>

          <div class="column-3" v-if="selectedType == 'schedule'">
            <label>Start date:</label>
            <div>
              <DatePicker
                format="YYYY-MM-DD"
                placeholder="Select Date"
                v-model="startDate"
                value-type="format"
                name="startDate"
                class="date-picker"
                :class="{ error: !validStartDate }"
              />
            </div>
          </div>
        </div>

        <div class="row HEL">
          <div class="column" :style="{ width: '40%' }">
            <label>Frequency:</label>
            <div
              class="notification-date-container"
              v-if="selectedType == 'reminder'"
            >
              <div
                v-for="date of reminderDates"
                class="notification-date"
                :class="{
                  'notification-date-selected':
                    selectedDate == date ? true : false,
                  error: !validDate
                }"
                :key="date"
                @click="selDate(date)"
              >
                {{ date }}
              </div>
            </div>
            <div v-else>
              <div class="notification-date-container">
                <div
                  v-for="date of scheduleDates"
                  class="notification-date"
                  :class="{
                    'notification-date-selected':
                      selectedDate == date ? true : false,
                    error: !validDate
                  }"
                  :key="date"
                  @click="selDate(date)"
                >
                  {{ date }}
                </div>
              </div>
            </div>
          </div>

          <div class="column" v-if="selectedType == 'schedule'">
            <label>Day of the week:</label>
            <div
              class="notification-date-container"
              v-if="selectedDate == 'Daily'"
            >
              <div
                v-for="date of weekDays"
                class="notification-date notification-date-selected"
                :class="{ error: !validDate }"
                :key="date"
              >
                {{ date }}
              </div>
            </div>

            <div class="notification-date-container" v-else>
              <div
                v-for="date of weekDays"
                class="notification-date weekday"
                :class="{
                  'notification-date-selected':
                    selectedWeekDate == date ? true : false,
                  error: !validDate
                }"
                :key="date"
                @click="selWeekDate(date)"
              >
                {{ date }}
              </div>
            </div>
          </div>

          <div class="column-3" :style="{ width: '25%' }">
            <label>Choose time:</label>
            <div class="double-select">
              <select
                class="tall-input hours"
                v-model="time.hours"
                :class="{ error: !validTime }"
              >
                <option
                  v-for="hour of hours"
                  :value="parseInt(hour, 10)"
                  :key="hour"
                >
                  {{ hour }}
                </option>
              </select>
              <select
                class="tall-input minutes"
                v-model="time.minutes"
                :class="{ error: !validTime }"
              >
                <option
                  v-for="minute of minutes"
                  :value="parseInt(minute, 10)"
                  :key="minute"
                >
                  {{ minute }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row HEL">
          <div class="column-text-area">
            <label>Message:</label>
            <textarea
              v-model="message"
              name="text-area"
              id="text-area"
              cols="30"
              rows="10"
              placeholder="Write here your message"
              maxlength="360"
              :class="{ error: !validMessage }"
            ></textarea>
          </div>
          <div class="column-right-panel">
            <div class="right-panel">
              <generic-search
                :things="searchOptions"
                searchThing="option"
                class="generic-search"
                :key="'calendar-property-filter'"
                @displayVariable="displayVariable"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="form-footer">
        <button @click="goBack" class="btn">&lt; Back</button>
        <button @click="createNew" class="btn create">
          {{ buttonVariable }}
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import calls from '@/api/calls'
import GenericSearch from '@/components/GenericSearch'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import Loader from '@/components/Loader.vue'

export default {
  name: 'NewNotificationScreen',
  components: {
    GenericSearch,
    DatePicker,
    Loader
  },
  data() {
    return {
      buttonVariable: 'Create',
      subtitle: 'Notification',
      properties: [],
      notifications: [],
      chores: [],
      chore: null,
      property: null,
      propertyName: null,
      editing: false,
      choreLink: 'https://biz.rentalios.com/chores/publiclList?property=',
      searchOptions: [
        'assignment date',
        'chore name',
        'schedule link',
        'schedule text',
        'housemate name',
        'property name',
        'property manager'
      ],
      types: ['reminder', 'schedule'],
      message: '',
      mappedMessage: '',
      selectedNotification: null,
      selectedType: 'reminder',
      selectedWeekDate: null,
      time: {
        minutes: 0,
        hours: 12
      },
      selectedProperty: null,
      selectedDate: null,
      startDate: null,
      reminderDates: ['Same day', '1 day before', '2 days before'],
      scheduleDates: ['Daily', 'Weekly', 'Every 2 weeks'],
      weekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23'
      ],
      minutes: ['00'],
      incompleteForm: false,
      isLoading: false,

      // validators
      validProperty: true,
      validChore: true,
      validType: true,
      validDate: true,
      validTime: true,
      validMessage: true,
      validStartDate: true
    }
  },
  computed: {
    bindPropertyName() {
      const propertyObject = this.properties.filter(
        (property) => property.uuid == this.property
      )
      return propertyObject[0]['name']
    },

    bindUTCOffset() {
      const propertyObject = this.properties.filter(
        (property) => property.uuid == this.property
      )
      return propertyObject[0]['utcoffset']
    },

    bindChoreName() {
      const choreObject = this.chores.filter(
        (chore) => chore.uuid == this.chore
      )
      return choreObject[0]['name']
    },
    calculateOffset() {
      let offset
      switch (this.selectedDate) {
        case 'Same day':
          offset = 0
          break
        case '1 day before':
          offset = 1
          break
        case '2 days before':
          offset = 2
          break
        case 'Daily':
          offset = 0
          break
        case 'Weekly':
          offset = 1
          break
        case 'Every 2 weeks':
          offset = 2
          break
      }
      return offset
    },
    calculateWeekDate() {
      let weekNumber

      switch (this.selectedWeekDate) {
        case 'Sun':
          weekNumber = '0'
          break
        case 'Mon':
          weekNumber = '1'
          break
        case 'Tue':
          weekNumber = '2'
          break
        case 'Wed':
          weekNumber = '3'
          break
        case 'Thu':
          weekNumber = '4'
          break
        case 'Fri':
          weekNumber = '5'
          break
        case 'Sat':
          weekNumber = '6'
          break
      }
      return weekNumber
    },

    getPropertyTimeZone() {
      const timezone = this.properties.filter(
        (property) => property.uuid == this.property
      )
      return timezone[0]['timezone']
    },
    getCronExpression() {
      const choreObject = this.chores.filter(
        (chore) => chore.uuid == this.chore
      )
      return choreObject[0]['schedule']
    }
  },
  methods: {
    displayVariable(thing) {
      let currentPosition = document.getElementById('text-area').selectionStart
      thing = thing.split(' ')
      thing = '{{' + thing[0] + '_' + thing[1] + '}}'
      const finalText =
        this.message.slice(0, currentPosition) +
        thing +
        this.message.slice(currentPosition)
      this.message = finalText
    },
    calculateDate(offset, type) {
      let date

      //calculates reminder
      if (offset == 0 && type == 'reminder') date = 'Same day'
      else if (offset == 1 && type == 'reminder') date = '1 day before'
      else if (offset == 2 && type == 'reminder') date = '2 days before'
      //calculates schedule
      else if (offset == 0 && type == 'schedule') date = 'Daily'
      else if (offset == 1 && type == 'schedule') date = 'Weekly'
      else if (offset == 2 && type == 'schedule') date = 'Every 2 weeks'

      return date
    },
    calculateWeekDay() {
      let cronExpresion = this.selectedNotification.cronExpresion
      let offset = parseInt(
        cronExpresion.charAt(this.selectedNotification.cronExpresion.length - 1)
      )

      let day
      switch (offset) {
        case 0:
          day = 'Sun'
          break
        case 1:
          day = 'Mon'
          break
        case 2:
          day = 'Tue'
          break
        case 3:
          day = 'Wed'
          break
        case 4:
          day = 'Thu'
          break
        case 5:
          day = 'Fri'
          break
        case 6:
          day = 'Sat'
          break
      }
      return day
    },
    async createNew() {
      this.isLoading = true
      this.checkErrors()
      if (!this.incompleteForm) {
        // Save parameter to the backend on chores notifications, not the actual content
        // this.message = this.changeVariables()

        if (this.selectedType == 'reminder') {
          const bodyReminder = {
            propertyID: this.property,
            choreID: this.chore,
            cronExpresion: this.getCronExpression,
            timezone: this.getPropertyTimeZone,
            dateOffset: this.calculateOffset,
            time: this.time,
            message: this.message,
            type: this.selectedType
          }

          const { message, data } = this.editing
            ? await calls.PUT(
                'notifications',
                this.selectedNotification.uuid,
                bodyReminder
              )
            : await calls.POST('notifications', bodyReminder)
        } else {
          let newDate = moment(this.startDate)
            .utcOffset(this.bindUTCOffset)
            .toISOString()
          newDate = new Date(newDate)
          newDate.setUTCHours(0)
          const bodySchedule = {
            propertyID: this.property,
            choreID: this.chore,
            cronExpresion: this.getCronExpression,
            timezone: this.getPropertyTimeZone,
            dateOffset: this.calculateOffset,
            time: this.time,
            message: this.message,
            type: this.selectedType,
            scheduleDays: this.calculateWeekDate,
            startDate: newDate.toISOString()
          }

          const { message, data } = this.editing
            ? await calls.PUT(
                'notifications',
                this.selectedNotification.uuid,
                bodySchedule
              )
            : await calls.POST('notifications', bodySchedule)
        }

        this.$router.replace('/chores/notifications')
      }
      this.isLoading = false
    },

    checkErrors() {
      this.validProperty = this.property ? true : false
      this.validChore = this.chore ? true : false
      this.validType = this.selectedType ? true : false
      this.validDate = this.selectedDate ? true : false
      this.validTime = this.time ? true : false
      this.validMessage = this.message ? true : false
      this.validStartDate =
        this.selectedType !== 'schedule' || Boolean(this.startDate)

      if (
        this.validProperty &&
        this.validChore &&
        this.validType &&
        this.validDate &&
        this.validTime &&
        this.validMessage &&
        this.validStartDate
      ) {
        this.incompleteForm = false
      } else {
        this.incompleteForm = true
      }
    },

    // Save parameter to the backend on chores notifications, not the actual content
    // changeVariables() {
    //   let finalMessage

    //   finalMessage = this.mapMessageVariables(
    //     '{{assignment_date}}',
    //     '$assignment_date'
    //   )

    //   finalMessage = this.mapMessageVariables(
    //     '{{chore_name}}',
    //     this.bindChoreName
    //   )

    //   finalMessage = this.mapMessageVariables(
    //     '{{housemate_name}}',
    //     '$housemate_name'
    //   )

    //   finalMessage = this.mapMessageVariables(
    //     '{{schedule_link}}',
    //     this.choreLink + this.property
    //   )

    //   finalMessage = this.mapMessageVariables(
    //     '{{schedule_text}}',
    //     this.choreLink + this.property
    //   )

    //   finalMessage = this.mapMessageVariables(
    //     '{{property_name}}',
    //     this.bindPropertyName
    //   )

    //   finalMessage = this.mapMessageVariables(
    //     '{{property_manager}}',
    //     'Joe Parra'
    //   )

    //   this.message = finalMessage
    //   return this.message
    // },
    // mapMessageVariables(oldVal, newVal) {
    //   const regex = new RegExp(oldVal, 'g')
    //   this.message = this.message.replace(regex, newVal)

    //   return this.message
    // },

    selType(type) {
      this.selectedType = type
      if (type == 'schedule') this.searchOptions.splice(0, 1)
      else this.searchOptions.unshift('assignment date')
    },

    selDate(date) {
      this.selectedDate = date
    },
    selWeekDate(date) {
      this.selectedWeekDate = date
    },
    goBack() {
      this.$router.replace('/chores/notifications')
    },
    async onChangeProperty() {
      await this.updateChores()
    },
    async updateChores() {
      const { data, message } = await calls.GET(
        `chores/from/a/${this.property}`
      )
      this.chores = data
    },

    async loadProperties() {
      const { message, data } = await calls.GET('properties')
      this.properties = data
    },

    async loadChores() {
      const { message, data } = await calls.GET('chores')
      this.chores = data
    }
  },

  async created() {
    this.isLoading = true
    try {
      this.selectedNotification = this.$route.params.notification
      await this.loadProperties()
      await this.loadChores()
      if (this.selectedNotification) {
        this.editing = true
        this.buttonVariable = 'Update'
        this.selectedType = this.selectedNotification.type
        this.time = this.selectedNotification.time
        this.message = this.selectedNotification.message
        this.property = this.selectedNotification.propertyID
        this.chore = this.selectedNotification.choreID
        this.startDate = moment
          .utc(this.selectedNotification.startDate)
          .format('YYYY-MM-DD')
        this.selectedDate = this.calculateDate(
          this.selectedNotification.dateOffset,
          this.selectedNotification.type
        )
        this.selectedWeekDate = this.calculateWeekDay(
          this.selectedNotification.weekNumber
        )
        await this.onChangeProperty()
      }
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.new-notification-form {
  background-color: #f5f6f8;
  padding: 3% 3% 10% 3%;
  height: 100%;
}
.column label,
.column-3 label,
.column-text-area label {
  margin-bottom: 8px;
}
.notification-type-container,
.notification-date-container {
  display: flex;
  flex-direction: row;
}
.notification-type,
.notification-date {
  padding: 10px;
  height: 18px;
  border: solid 1px;
  border-radius: 4px;
  margin-right: 5px;
  border-color: #dfdfdf;
  color: #767675;
  cursor: pointer;
  text-align: center;
}

.notification-date {
  height: auto !important;
  width: fit-content !important;
  white-space: nowrap;
}

.notification-date.weekday {
  min-width: 32px;
  padding-left: 2px;
  padding-right: 2px;
}

.notification-type {
  width: 40%;
}

.notification-type-selected,
.notification-date-selected {
  border: solid 1px;
  border-color: var(--rentalios-dark);
  background-color: #ebf0e6;
  color: var(--rentalios-dark);
}
.subtitle {
  width: 158.25px;
  height: 22px;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #66b015;
}

.form-body {
  height: 60vh;
  padding: 3% 15% 3% 15%;
  background-color: white;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  overflow-y: scroll;
}
.form-body .row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 0 0 0;
}

.column,
.column-3,
.column-right-panel,
.column-text-area {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 0;
}

.form-body .column {
  width: 48%;
  /* margin-right:15px; */
}

.form-body .column-3 {
  width: 31%;
}

.column-right-panel {
  width: 35%;
}

.column-text-area {
  width: 57%;
}

.form-body .column-3 .double-select {
  flex-flow: row nowrap;
  justify-content: space-between;
}

.form-body .column-3 .double-select Select {
  width: 45%;
}

.form-body .column-3 .double-select .hours {
  width: 64px;
  margin-right: 9%;
}

.form-body .column-3 .double-select .minutes {
  width: 64px;
}

.tall-input {
  height: 40px;
  border: solid 1px;
  border-radius: 4px;
  border-color: #dfdfdf;
  margin: 0;
  padding: 0;
  padding-left: 8px;
}

.form-footer {
  height: 80px;
  border-top: solid 1px #dfdfdf;
  background-color: white;
  display: flex;
  justify-content: space-between;
  padding: 2% 25% 0 25%;
}

.form-footer .btn:hover {
  text-decoration: underline;
}

.form-footer .btn {
  height: 48px;
  width: 80px;
  left: 0px;
  top: 16px;
  border-radius: nullpx;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  background-color: white;
  outline: none;
  border: none;
  color: #66b015;
  cursor: pointer;
}

.form-footer .btn.create {
  background-color: #66b015;
  color: white;
  width: 192px;
}

.HEL {
  margin: 2% 0 2% 0;
}

.field-errors {
  margin: 4px 0 8px 0;
  padding-left: 20px;
  color: red;
  font-size: 13px;
  font-family: Montserrat;
  list-style: disc;
}

.field-errors li {
  margin-bottom: 2px;
}

.error-message {
  color: red;
  font-size: 16px;
  font-family: Montserrat;
}

.create-property-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 22px;
  color: #66b015;
  margin-top: 24px;
}

select,
option {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
}

#text-area {
  height: 368px;
  border: solid 1px;
  border-radius: 4px;
  border-color: #dfdfdf;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  padding-left: 10px;
  padding-top: 10px;
  width: 100%;
}

#text-area:focus {
  outline: none !important;
}

.generic-search {
  margin-top: 25px;
}

.error {
  border-color: red !important;
}
div.mx-datepicker {
  width: 100%;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .new-notification-form {
    padding: 16px;
    height: auto;
    min-height: 100vh;
    width: 100%;
    max-width: 100%;
  }

  .form-body {
    height: auto;
    min-height: 80vh;
    padding: 20px;
    margin: 0 auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 95%;
    max-width: 95%;
    box-sizing: border-box;
  }

  .subtitle {
    width: 100%;
    height: auto;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 20px;
    text-align: center;
  }

  .error-message {
    font-size: 14px;
    margin-bottom: 20px;
    text-align: center;
    padding: 12px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    color: #dc2626;
    width: 100%;
    box-sizing: border-box;
  }

  .form-body .row {
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
    width: 100%;
  }

  .column,
  .column-3,
  .column-right-panel,
  .column-text-area {
    width: 100% !important;
    margin-bottom: 16px;
    box-sizing: border-box;
  }

  .column label,
  .column-3 label,
  .column-text-area label {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    display: block;
    width: 100%;
  }

  .notification-type-container,
  .notification-date-container {
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .notification-type {
    width: 100% !important;
    height: 44px;
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 6px;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-sizing: border-box;
  }

  .notification-date {
    height: 44px !important;
    width: 100% !important;
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 6px;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-sizing: border-box;
  }

  .notification-date.weekday {
    min-width: auto;
    padding: 12px 16px;
  }

  .notification-type-selected,
  .notification-date-selected {
    background-color: #66b015;
    border-color: #66b015;
    color: white;
    transform: scale(1.02);
  }

  .tall-input {
    height: 44px;
    padding: 12px 16px;
    font-size: 16px;
    border-radius: 6px;
    border: 2px solid #e1e5e9;
    transition: all 0.2s ease;
    width: 100%;
    box-sizing: border-box;
  }

  .tall-input:focus {
    border-color: #66b015;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 176, 21, 0.1);
  }

  .tall-input.error {
    border-color: #dc2626;
  }

  /* Enhanced date picker for mobile */
  ::v-deep .mx-datepicker {
    width: 100%;
    max-width: 100%;
  }

  ::v-deep .mx-input {
    height: 44px;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 6px;
    font-size: 16px;
    background: white;
    color: #333;
    transition: all 0.2s ease;
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .mx-input:focus {
    border-color: #66b015;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 176, 21, 0.1);
  }

  ::v-deep .mx-input.error {
    border-color: #dc2626;
  }

  /* Enhanced textarea for mobile */
  #text-area {
    height: 200px;
    padding: 16px;
    font-size: 16px;
    border: 2px solid #e1e5e9;
    border-radius: 6px;
    transition: all 0.2s ease;
    resize: vertical;
    min-height: 120px;
    width: 100%;
    box-sizing: border-box;
  }

  #text-area:focus {
    border-color: #66b015;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 176, 21, 0.1);
  }

  /* Enhanced form footer for mobile */
  .form-footer {
    height: auto;
    padding: 20px;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    border-top: 2px solid #f0f0f0;
    background: white;
    position: sticky;
    bottom: 0;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    width: 95%;
    max-width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .form-footer .btn {
    height: 48px;
    width: 100%;
    max-width: 200px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    cursor: pointer;
    border: none;
  }

  .form-footer .btn.create {
    background-color: #66b015;
    color: white;
    width: 100%;
    max-width: 200px;
  }

  .form-footer .btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  /* Better mobile spacing */
  .HEL {
    margin: 16px 0;
  }

  /* Enhanced mobile scrolling */
  .form-body::-webkit-scrollbar {
    width: 6px;
  }

  .form-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .form-body::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .form-body::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Mobile-specific touch improvements */
  .notification-type:active,
  .notification-date:active {
    transform: scale(0.98);
  }

  .form-footer .btn:active {
    transform: scale(0.98);
  }

  /* Generic search component width fix */
  .generic-search {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Double select container width fix */
  .double-select {
    width: 100%;
    display: flex;
    gap: 10px;
  }

  .double-select .hours,
  .double-select .minutes {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 480px) {
  .new-notification-form {
    padding: 0px;
    width: 100%;
    max-width: 100%;
    top: 5px;
    position: relative;
  }

  .form-body {
    padding: 16px;
    margin: 0 auto;
    border-radius: 6px;
    width: 95%;
    max-width: 95%;
  }

  .subtitle {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .error-message {
    font-size: 13px;
    margin-bottom: 16px;
    padding: 10px;
    border-radius: 4px;
  }

  .form-body .row {
    gap: 16px;
    margin-bottom: 16px;
  }

  .column,
  .column-3,
  .column-right-panel,
  .column-text-area {
    margin-bottom: 12px;
  }

  .column label,
  .column-3 label,
  .column-text-area label {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .notification-type-container,
  .notification-date-container {
    gap: 6px;
  }

  .notification-type,
  .notification-date {
    height: 40px;
    padding: 10px 14px;
    font-size: 13px;
    border-radius: 4px;
    width: 90% !important;
  }

  .notification-date.weekday {
    padding: 10px 14px;
  }

  .tall-input {
    height: 40px;
    padding: 10px 14px;
    font-size: 16px;
    border-radius: 4px;
  }

  ::v-deep .mx-input {
    height: 40px;
    padding: 10px 14px;
    border-radius: 4px;
    font-size: 16px;
  }

  #text-area {
    height: 180px;
    padding: 14px;
    font-size: 16px;
    border-radius: 4px;
    min-height: 100px;
    width: 90% !important;
  }

  .form-footer {
    padding: 16px;
    gap: 12px;
    width: 95%;
    max-width: 95%;
  }

  .form-footer .btn {
    height: 44px;
    font-size: 15px;
    border-radius: 6px;
    max-width: 180px;
  }

  .form-footer .btn.create {
    max-width: 180px;
  }

  /* Enhanced mobile accessibility */
  .notification-type,
  .notification-date,
  .form-footer .btn {
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  /* Mobile-optimized shadows */
  .form-body {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .form-footer {
    box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.08);
  }

  /* Better mobile spacing */
  .HEL {
    margin: 12px 0;
  }

  /* Generic search component width fix for small mobile */
  .generic-search {
    width: 100%;
    max-width: 100%;
  }

  /* Double select container width fix for small mobile */
  .double-select {
    width: 100%;
    gap: 8px;
  }
}
</style>
